import React from "react";
const defaultFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};
export const FormattedValue = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    value,
    postfix,
    className,
    formatOptions = defaultFormatOptions
  } = _ref;
  const formattedValue = (value !== null && value !== void 0 ? value : 0).toLocaleString("no-NO", formatOptions);
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    ref: ref
  }, formattedValue, postfix ? " ".concat(postfix) : "");
});